var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_attendanceRecord_list_title"),
      filterable: "",
      pad: "0",
    },
    on: {
      activated: _vm.activated,
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "nav-actions",
        fn: function () {
          return [
            _vm.viewMode == 0 && _vm.hasBtn("unlock-admin-attendance-record")
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "mr-2 text-capitalize primary",
                                      attrs: {
                                        color: "white",
                                        loading: _vm.lockloading,
                                        icon: "",
                                        width: "36",
                                        height: "36",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.batchLock(0)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("lock_open")]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      553941663
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message_essweb_attendanceRecord_list_tools_batchUnLockTip"
                          )
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.viewMode == 0 && _vm.hasBtn("lock-admin-attendance-record")
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "mr-2 text-capitalize primary",
                                      attrs: {
                                        color: "white",
                                        icon: "",
                                        width: "36",
                                        height: "36",
                                        loading: _vm.lockloading2,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.batchLock(1)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("lock")]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1335727975
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message_essweb_attendanceRecord_list_tools_batchLockTip"
                          )
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.hasBtn("recalculate-admin-attendance-record")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "text-capitalize mr-2 primary",
                    attrs: { color: "white", depressed: "", rounded: "" },
                    on: {
                      click: function ($event) {
                        _vm.showRecalcul = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "label_essweb_RosterRecord_list_recalulateBtnLabel"
                        )
                      )
                    ),
                  ]
                )
              : _vm._e(),
            _vm.curTab == "tab-1" &&
            _vm.hasBtn("export-admin-attendance-record")
              ? _c(
                  "v-btn",
                  {
                    attrs: {
                      rounded: "",
                      color: "primary mr-2 text-capitalize",
                    },
                    on: {
                      click: function ($event) {
                        _vm
                          .$confirmWarn(
                            _vm.$t("label_Download_the_CVS"),
                            _vm.$t(
                              "message_essweb_system_operation_export_outLabel"
                            ),
                            null,
                            _vm.$t(
                              "message_essweb_system_operation_export_exportOutLabel"
                            )
                          )
                          .then(function (res) {
                            if (res) {
                              _vm.exportOut(_vm.viewMode)
                            }
                          })
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("label_Download_the_CVS")) + " ")]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c(
              "v-btn-toggle",
              {
                staticClass:
                  "\n        text-capitalize\n        rounded-lg\n        grey\n        lighten-2\n        mr-3\n        d-flex\n        align-center\n      ",
                staticStyle: { height: "36px !important", padding: "1px" },
                attrs: {
                  mandatory: "",
                  borderless: "",
                  "active-class": " elevation-3 rounded-lg ",
                },
                model: {
                  value: _vm.viewMode,
                  callback: function ($$v) {
                    _vm.viewMode = $$v
                  },
                  expression: "viewMode",
                },
              },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "text-capitalize spe_btn text-button",
                    attrs: {
                      small: "",
                      height: "36",
                      color:
                        _vm.viewMode == 0
                          ? "white primary--text"
                          : "grey lighten-2 text--secondary",
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("reorder"),
                    ]),
                  ]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "text-capitalize spe_btn text-button",
                    attrs: {
                      height: "36",
                      small: "",
                      color:
                        _vm.viewMode == 1
                          ? "white primary--text"
                          : "grey lighten-2 text--secondary",
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons-round" }, [
                      _vm._v("view_module"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c("v-spacer"),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.viewMode == 0,
                    expression: "viewMode == 0",
                  },
                ],
              },
              [
                _c("Selections2", {
                  attrs: { objects: _vm.filterObjects, "small-chip": "" },
                  on: {
                    close: function ($event) {
                      _vm.filterable = !_vm.filterable
                    },
                    filter: function ($event) {
                      filter()
                      _vm.toFilter(1, filter)
                    },
                    update: function (prop, value, selected) {
                      _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                    },
                    reset: function (apply) {
                      _vm.$fliterValue(_vm.filterObjects, null, null)
                      if (apply) {
                        filter()
                        _vm.toFilter(1, filter)
                      }
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.viewMode == 1,
                    expression: "viewMode == 1",
                  },
                ],
              },
              [
                _c("Selections2", {
                  attrs: { objects: _vm.filterObjects2, "small-chip": "" },
                  on: {
                    close: function ($event) {
                      _vm.filterable = !_vm.filterable
                    },
                    filter: function ($event) {
                      filter()
                      _vm.toFilter(2, filter)
                    },
                    update: function (prop, value, selected) {
                      if (prop == "department") {
                        _vm.curDept = value
                      } //触发岗位更新下拉
                      _vm.$fliterValue(
                        _vm.filterObjects2,
                        prop,
                        value,
                        selected
                      )
                    },
                    reset: function (apply) {
                      _vm.$fliterValue(_vm.filterObjects2, null, null)
                      if (apply) {
                        filter()
                        _vm.toFilter(2, filter)
                      }
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.viewMode == 0,
                  expression: "viewMode == 0",
                },
              ],
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                defaultSelect: _vm.selected,
                showSelect: _vm.showSelect && !_vm.isLoading,
                "filter-page-data": _vm.filterPageData,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                totalCount: _vm.totalCount,
                overLoading: "",
              },
              on: {
                select: _vm.onSelect,
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.date",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(item.utc_att_date, "YYYY/MM/DD")
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.staff",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "300px" } },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "pa-0 ma-0",
                              attrs: { dense: "", "two-line": "" },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                {
                                  staticClass: "mr-1 my-0 pa-0",
                                  attrs: { size: "36" },
                                },
                                [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      isTemp: item.is_temp,
                                      src: item.staff_avatar,
                                      staff_name: item.preferred_name,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.preferred_name
                                        )
                                      ) + " "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text--secondary text-caption-xs",
                                      },
                                      [_vm._v(" " + _vm._s(item.staff_code))]
                                    ),
                                  ]),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.job_post_name
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.schedule_shift",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.schedule_shift_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.site_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$getCommonLangValue(item.site_name)) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.cost_center",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.cost_center_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.official_shift",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.official_shift_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.tag",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap justify-start",
                          staticStyle: { "max-width": "200px" },
                        },
                        [
                          Number(item.is_late)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_late_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_lateLabel"
                                      )
                                    ) +
                                      "(" +
                                      _vm._s(
                                        item.official_total_late_minutes || 0
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_minutesLabel"
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_ot)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_ot_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_otLabel"
                                      )
                                    ) +
                                      "(" +
                                      _vm._s(
                                        item.official_total_ot_minutes || 0
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_minutesLabel"
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_early_leave)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_early_leave_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_earlyLeaveLabel"
                                      )
                                    ) +
                                      "(" +
                                      _vm._s(
                                        item.official_total_early_leave_minutes ||
                                          0
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_minutesLabel"
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_absense)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_absense_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_absenseLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_work_from_home)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 text--primary",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_work_from_home_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_locked)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_locked_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isLockedLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_adhoc)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 text--primary",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_adhoc_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isAdhocLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_missing_punch)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_missing_punch_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isMissingPunchLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_out_of_office)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 text--primary",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_out_of_office_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isOutOfOfficeLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_onDuty)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_on_duty_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isOnDutyLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(item.leave_info, function (leave, index) {
                            return _c(
                              "v-chip",
                              {
                                key: "leave--" + index,
                                staticClass: "ma-1",
                                attrs: {
                                  small: "",
                                  outlined: "",
                                  color: leave.color_code,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      leave["leave_type_name"]
                                    )
                                  )
                                ),
                              ]
                            )
                          }),
                          _vm._l(item.holiday_info, function (holiday, index) {
                            return _c(
                              "v-chip",
                              {
                                key: "holiday--" + index,
                                staticClass: "ma-1 text--primary",
                                attrs: {
                                  small: "",
                                  color: _vm.$getTagColors(
                                    _vm.$card_line_colors,
                                    "is_holiday_1"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      holiday["holiday_name"]
                                    )
                                  )
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "item.schedule_setime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column text-truncate" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item.schedule_start_utc_time,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                          _c("v-divider", {
                            staticClass: "mx-auto mrc-border-dashed",
                            staticStyle: { width: "90%" },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item.schedule_end_utc_time,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.official_setime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column text-truncate" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item.official_start_utc_time,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                          _c("v-divider", {
                            staticClass: "mx-auto mrc-border-dashed",
                            staticStyle: { width: "90%" },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item.official_end_utc_time,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.official_IO",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column text-truncate" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item.official_punch_in_utc_datetime,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                          _c("v-divider", {
                            staticClass: "mx-auto mrc-border-dashed",
                            staticStyle: { width: "90%" },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item.official_punch_out_utc_datetime,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.actual",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column text-truncate" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$getDateTime(
                                  item.actual_punch_in_utc_datetime,
                                  "HH:mm"
                                )
                              )
                            ),
                          ]),
                          _c("v-divider", {
                            staticClass: "mx-auto mrc-border-dashed",
                            staticStyle: { width: "90%" },
                          }),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getDateTime(
                                    item.actual_punch_out_utc_datetime,
                                    "HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.official_work_minutes",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " + _vm._s(item.official_working_minutes || 0) + " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.official_late_minutes",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.official_total_late_minutes || 0) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.official_earlyleave_minutes",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.official_total_early_leave_minutes || 0
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.official_ot_minutes",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.official_total_ot_minutes || 0) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.official_absense_minutes",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$timeMachine(
                                item.official_absense_minutes || 0
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.official_before_minutes",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$timeMachine(
                                item.official_before_work_minutes || 0
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.official_after_minutes",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$timeMachine(
                                item.official_after_work_minutes || 0
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm.hasBtn("view-admin-attendance-record")
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.toView(item.uuid)
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  size: "24",
                                  fill: "currentColor",
                                  iconClass: "viewDetail",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("AttendancePlan", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.viewMode == 1,
                  expression: "viewMode == 1",
                },
              ],
              attrs: {
                cycleType: _vm.cycleType,
                startTime: _vm.startTime,
                iSEdited: _vm.iSEdited,
                selectStartDate: _vm.startDate,
                selectEndDate: _vm.endDate,
                "filter-data": _vm.filterData,
                endTime: _vm.endTime,
              },
              on: {
                reset: function (e) {
                  if (e) {
                    _vm.$fliterValue(_vm.filterObjects2, null, null)
                  }
                },
                onTrigerPage: function (logic, time) {
                  _vm.toResetTime(logic, time)
                },
                onShift: function (data, dete, master) {
                  _vm.toView(master["uuid"])
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("RecalculateDialog", {
              attrs: { show: _vm.showRecalcul, curStaffs: _vm.allStaff },
              on: {
                close: function ($event) {
                  _vm.showRecalcul = false
                },
                onSave: _vm.toReCalGen,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }